import Staking from "./staking/reducer";

export default {
  Staking
};
